import { graphql } from "@/gql";

export const relocationImageGenerations = graphql(`
  query RelocationImageGenerations($id: ID!) {
    relocationImageGenerations(id: $id) {
      __typename
      id
      active
      image {
        ...MediaFields
      }
      created_at
    }
  }
`);

export const setActiveImageGenerationMutation = graphql(`
  mutation SetDefaultImageGeneration($id: ID!) {
    setDefaultImageGeneration(id: $id) {
      id
      active
    }
  }
`);
